import * as React from 'react'
import { useTranslation } from 'react-i18next'

import Title from '../../ui/title/title'

import { ProfileShort } from '../../../store/commonTypes'

import moment from 'moment-mini'
import './header.sass'

interface Props {
    text: string
    self?: boolean
    user: ProfileShort
}

const PageHeader: React.FunctionComponent<Props> = ({ text, user, self = false }: Props) => {
    const [t] = useTranslation()

    return (
        <div className="header">
            <Title text={self ? text : user.nick} />
            {!self && (
                <span className={`status ${user.is_online ? 'status_online' : ''}`}>
                    {user.is_online
                        ? t('Online')
                        : `${t('Last online')} ${moment(user.last_online * 1000).format(t('time format'))}`}
                </span>
            )}
        </div>
    )
}

export default PageHeader
